import React, {useState} from "react";
import { Button } from "react-bootstrap";
import images from "./Events";
import {CSSTransition} from "react-transition-group";
import "../style/event.css";
import { ImageList, ImageListItem } from "@material-ui/core";
import welcome from "../data/eventpics/dumpling.jpg";

function current(){
    const cur = {src: welcome, link: "https://fb.me/e/3o4zkamvu", description: "Spring for Dumplings"};

    return <div class="eventContainer">
        {
            <a href={cur.link} target="_blank" rel="noreferrer"><img src={cur.src} class="current" alt={cur.description}/></a>
        }
    </div>;
}

function past(){
    return <div class="eventContainer">
        <ImageList rowHeight='auto' cols={3}>
            {images.map(({src, link, description}) => <ImageListItem><a href={link} target="_blank" rel="noreferrer"><img src={src} class="past" alt={description}/></a></ImageListItem>)}
        </ImageList>
    </div>;
}

function Event(){
    const [showCurrent, setShowCurrent] = useState(true);
    return <div id="event" className="text-center">
        <br/>
        <h1 style={{fontFamily: "Inter, sans-serif", paddingBottom: "2%", fontSize: "calc(20px + 3vw)", color: "white"}}>
            {showCurrent ? "Current Event" : "Past Event"}
        </h1>
        {showCurrent && (current())}
        <CSSTransition in={!showCurrent} timeout={500} classNames="past" onEnter={() => setShowCurrent(false)} onExited={() => setShowCurrent(true)} unmountOnExit>{past()}</CSSTransition>
        <br/>
        <Button onClick={() => setShowCurrent(!showCurrent)} size="lg" variant="warning" style={{color:"white"}}>
            <h3 style={{fontSize: "calc(10px + 2vw)"}}>
                {
                    showCurrent ? 'Show More' : 'Go Back'
                }
            </h3>
        </Button>
    </div>;
}

export default Event;